import { render, staticRenderFns } from "./RgLastObjectTracking.vue?vue&type=template&id=4666de3a&"
import script from "./RgLastObjectTracking.vue?vue&type=script&lang=js&"
export * from "./RgLastObjectTracking.vue?vue&type=script&lang=js&"
import style0 from "./RgLastObjectTracking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports